export default __webpack_public_path__ + "static/media/news.6bec3ee3.webp";